// import axios from 'axios'
import axios from '../../helpers/Axios'


export const tablelayoutmodule = {

	namespaced: true,

	state: {

		tableLayouts: [],
		selectedLayout: 1
	},
	getters: {

		tableLayouts: state => { return state.tableLayouts; }
	},
	actions: {

		getTableLayouts({ commit }) {
			return axios.get('/tablelayout').then(response => {

				commit('tableLayouts', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		tableLayouts(state, tableLayouts) {
			state.tableLayouts = tableLayouts
		},

		selectedLayout(state, selectedLayout) {
			state.selectedLayout = selectedLayout
		},

	}
}
